import { Component, Inject, OnDestroy, Renderer2 } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateConfigService } from '../../../../../services/translate-config.service';

@Component({
    selector: 'app-confirmation-modal',
    templateUrl: './confirmation-modal.component.html',
    styleUrls: ['./confirmation-modal.component.scss'],
    standalone: false
})
export class ConfirmationModalComponent implements OnDestroy {
    confirmationModalData :any 
    constructor(private dialog: MatDialogRef<boolean>, private translateConfigService: TranslateConfigService , @Inject(MAT_DIALOG_DATA) public data: any,
    private renderer : Renderer2) {
        this.confirmationModalData = data  
    }

    ngOnDestroy(): void {
        this.renderer.setStyle(document.body, 'pointer-events', 'auto');
    }

    close = (close: boolean): any => this.dialog.close(close);
}
